<script setup lang="ts">
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import '@splidejs/vue-splide/css';

    const props = defineProps<{ blok: TeaserSliderStoryblok }>();

    const splideOptions = {
        type: props.blok.looping ? 'loop' : 'slide',
        autoplay: props.blok.autoPlay ?? false,
        interval: props.blok.autoPlayDelay ?? 4000,
        arrows: props.blok.showArrows ?? true,
        pagination: props.blok.showPagination ?? true,
        perPage: props.blok.slidesPerPage ?? 1,
        perMove: props.blok.slidesPerMove ?? 1,
        drag: props.blok.dragFree ? 'free' : true,
        padding: props.blok.hasPadding ? '4rem' : false,
        breakpoints: {
            1024: {
                perPage: props.blok.slidesPerPage && props.blok.slidesPerPage >= 2 ? 2 : 1,
                perMove: props.blok.slidesPerMove && props.blok.slidesPerMove >= 2 ? 2 : 1
            },
            640: {
                perPage: 1,
                perMove: 1
            }
        },
        classes: {
            arrows: 'splide__arrows custom-splide-arrows',
            arrow: 'splide__arrow custom-splide-arrow',
            prev: 'splide__arrow--prev custom-splide-arrow-prev',
            next: 'splide__arrow--next custom-splide-arrow-next',
            pagination: 'splide__pagination custom-splide-pagination'
        }
    };
</script>

<template>
    <div
        class="slider-bleed"
        :class="{ '--show-hidden': blok.showHiddenElements }"
    >
        <div
            class="slider-wrapper"
            :class="{
                '--round-corners': blok.roundCorners,
                '--full-width': blok.fullWidth
            }"
        >
            <Splide :options="splideOptions">
                <SplideSlide
                    v-for="object in blok.slideContent"
                    :key="object._uid"
                    class="slide"
                >
                    <StoryblokComponentWrapper :blok="object" />
                </SplideSlide>
            </Splide>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/teaser/teaser-slider.scss';

    :deep(.custom-splide-arrow) {
        display: none;
    }

    :deep(.custom-splide-arrow-prev) {
        left: $spacing;
    }

    :deep(.custom-splide-arrow-next) {
        left: calc(48px + $spacing--2);
    }

    :deep(.custom-splide-pagination) {
        li button {
            background: $black;
            opacity: 1;
            height: 8px;
            width: 8px;
        }

        .is-active {
            width: 40px;
            border-radius: 6px;
            transform: scale(1);
            transition: width 0.3s ease;
        }
    }

    @media (min-width: $br-m) {
        :deep(.custom-splide-arrow) {
            top: calc(100% - 26px);
            display: flex;
        }
    }
</style>
